import { parseApiDate } from '@flatsy/utils/Functions/DateTime/Date'
import { format } from '@flatsy/utils/Functions/DateTime/Datefns'
import { useEffect, useState } from 'react'
import { Slot } from 'src/redux/slices/BookableSlots'
import { hightlightSlots, HookReturn } from './Type'

const useHightlight = (slots: Slot[] | undefined): HookReturn => {
  const [arraySlot, setArraySlot] = useState<hightlightSlots[]>([])

  useEffect(() => {
    if (slots) {
      const createArray: hightlightSlots[] = []
      const slotArray = [...slots]
      slotArray.splice(0, 6).forEach((slot) => {
        createArray.push({
          label: format(parseApiDate(`${slot.date}T${slot.start_time}`), "eeee dd MMMM 'à' HH:mm"),
          startDate: slot.date,
          startTime: slot.start_time,
          fullDate: `${slot.date}T${slot.start_time}`,
        })
      })

      setArraySlot(createArray)
    }
  }, [slots])

  return {
    hightlightSlots: arraySlot,
  }
}

export default useHightlight
